module.exports = __webpack_public_path__ + "images/seven-year-club-cc5c093be141f679cdd2d7a2a12345af.png";